module.exports = __webpack_public_path__ + "static/media/blogImg1.603645ee.png";